import { SsoOpenIdConnectionResult } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Stack, Typography } from '@optimus-web/core';
import { SsoDetailsPanelConnectionConfig } from './SsoDetailsPanelConnectionConfig';
import { SsoDetailsPanelUserDomains } from './SsoDetailsPanelUserDomains';

export interface SsoDetailsPanelContentProps {
    data: SsoOpenIdConnectionResult;
}

export function SsoDetailsPanelContent({ data }: SsoDetailsPanelContentProps) {
    const domains = data.domains || [];

    return (
        <Stack spacing="400" vertical>
            <SsoDetailsPanelSection title={TextKey.SsoDetailsOpenIdContentSectionTitle}>
                <SsoDetailsPanelConnectionConfig data={data} />
            </SsoDetailsPanelSection>
            <SsoDetailsPanelSection title={TextKey.SsoDetailsUserDomainsContentSectionTitle}>
                <SsoDetailsPanelUserDomains data={domains} />
            </SsoDetailsPanelSection>
        </Stack>
    );
}

const SsoDetailsPanelSection = ({ title, children }: React.PropsWithChildren<{ title: Mews.TextKey }>) => (
    <Stack spacing="200" as="section" vertical>
        <Typography textStyle="titleSmallStrong" as="div">
            <LocalizedText textKey={title} />
        </Typography>
        {children}
    </Stack>
);
